import { getYear } from "date-fns"

import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWORK } from "../../../../common/constants/appRoad"
import { useRoadworksQuery } from "../../../../common/hooks/queries/useRoadworksQuery"

import { roadworksQueryKeys } from "./queryKeys"

export function useRoadworksQuartersStats(config = {}) {

    const currentYear = getYear(new Date())
    const queryParameters = useExtendWithSubnetworks({
        year: currentYear,
    }, API_MODULE_ROADWORK, "sub_networks")

    const url = "roadworks/stats/quarters/"
    const queryKey = roadworksQueryKeys["quartersStats"](queryParameters)

    return useRoadworksQuery(
        url,
        queryKey,
        queryParameters,
        { ...config, enabled: !!currentYear },
    )
}